import {useEffect} from 'react';
import type {Asset, AssetGroup} from '@deviceinsight/ng-ui-api-client';
import {fetchAssetWithShadowById} from '@deviceinsight/ng-ui-api-client';
import {ELEMENT_CLASSNAME} from '../utils/consts';
import {markMissingAssets} from '../config/FloorplanWidgetDeviceUtils';
import {WidgetSvg} from './types';

const useAssetsFromFloorplanSvg = (
	svgRootObj: WidgetSvg | undefined,
	setAssetsCached: (arg0: Array<Asset>) => void,
	assetGroup: AssetGroup | null | undefined,
	setLoading: (arg0: boolean) => void
) => {
	useEffect(() => {
		if (svgRootObj && assetGroup) {
			setLoading(true);
			const elements = svgRootObj.select(`g.${ELEMENT_CLASSNAME}`);
			const assetPromises: Promise<Asset>[] = [];
			elements?.members.forEach((member) => {
				const assetId = parseInt(member.attr('id').replace('added_device_', ''));
				assetPromises.push(fetchAssetWithShadowById(assetId));
			});
			Promise.all(assetPromises).then((assets) => {
				const assetsInGroup = assets.filter((asset) =>
					asset.assetGroupIds.find((groupId) => groupId === assetGroup.id)
				);
				markMissingAssets(svgRootObj, assetsInGroup);
				setAssetsCached(assetsInGroup);
				setLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [svgRootObj]);
};

export default useAssetsFromFloorplanSvg;
